module.exports = __webpack_public_path__ + "assets/img/services.5c8e2b35.png";